namespace RedBullMOBILE360.CustomerCare {
    export class LineTerminationReportColumns {
        static columnsKey = 'CustomerCare.LineTerminationReport';
    }
}